import { render, staticRenderFns } from "./AdminTasks.vue?vue&type=template&id=5e7fa1cc&lang=pug&"
import script from "./AdminTasks.vue?vue&type=script&lang=ts&"
export * from "./AdminTasks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports